import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationIndividual6MasterReferenceData = createAsyncThunk(
  'stop/getVerificationIndividual6MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationIndividual6MasterReferenceSlice = createSlice({
  name: 'stop/verificationIndividual6MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationIndividual6MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationIndividual6MasterReferenceData.fulfilled]: (
      state,
      action
    ) => action.payload,
  },
});

export const { resetVerificationIndividual6MasterReference } =
  verificationIndividual6MasterReferenceSlice.actions;

export default verificationIndividual6MasterReferenceSlice.reducer;
